export function mergeClasses<T, S>(
    baseClasses: T,
    newClasses?: S
): Required<T & S> {
    if (!newClasses) {
        return baseClasses as Required<T & S>;
    }

    const nextClasses = { ...baseClasses };

    //if (
    //    process.env.NODE_ENV !== "production" &&
    //    typeof newClasses === "string"
    //) {
    //    return baseClasses as Required<T & S>; // why?
    //}

    Object.keys(newClasses).forEach(key => {
        if (newClasses[key]) {
            nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
        }
    });

    return nextClasses as Required<T & S>;
}
